package horcrux.browserapp.configs

import dev.gitlive.firebase.FirebaseOptions

object FirebaseConfigs {
    val FIREBASE_OPTIONS: FirebaseOptions = FirebaseOptions(
        applicationId = "1:118170158486:web:8b836d03b6ee3a44ed49b7",
        apiKey = "AIzaSyBSGw6xFz2E8LSl5njtH2TwWbv2scThRVs",
        storageBucket = "horcrux-27313.appspot.com",
        projectId = "horcrux-27313",
        authDomain = "horcrux-27313.firebaseapp.com"
    )
}
